// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bC4d","tabsBox":"styles_tabsBox__1sWCE","createButton":"styles_createButton__3pV3X"};